'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CitySelect = require('./CitySelect');

var _CitySelect2 = _interopRequireDefault(_CitySelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _CitySelect2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-city-select/build/index.js
// module id = 628
// module chunks = 0